import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen w-full bg-gray-50 p-4 md:p-6">
      <div className="max-w-3xl mx-auto space-y-6">
        <Button
          variant="outline"
          onClick={() => navigate(-1)}
          className="rtl-button-icon"
        >
          חזור
          <ChevronRight className="h-4 w-4" />
        </Button>

        <div className="bg-white p-6 rounded-lg shadow-sm space-y-6">
          <h1 className="text-2xl font-bold text-right">מדיניות פרטיות</h1>

          <div className="space-y-4 text-right">
            <section className="space-y-2">
              <h2 className="text-xl font-semibold">איסוף מידע</h2>
              <p>
                אנו אוספים מידע אישי כגון שם, כתובת דואר אלקטרוני והעדפות תזונה
                כאשר אתם נרשמים לשירות שלנו. מידע זה משמש אותנו כדי להתאים את
                חווית השימוש שלכם ולספק לכם את השירות הטוב ביותר.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-xl font-semibold">שימוש במידע</h2>
              <p>
                המידע שנאסף משמש אותנו ליצירת תוכניות ארוחות מותאמות אישית,
                שיפור השירות שלנו, ותקשורת איתכם לגבי עדכונים ושינויים בשירות.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-xl font-semibold">אבטחת מידע</h2>
              <p>
                אנו נוקטים באמצעי אבטחה מתקדמים כדי להגן על המידע האישי שלכם
                מפני גישה, שימוש או חשיפה בלתי מורשים.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-xl font-semibold">שיתוף מידע</h2>
              <p>
                איננו משתפים את המידע האישי שלכם עם צדדים שלישיים ללא הסכמתכם,
                למעט במקרים הנדרשים על פי חוק.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-xl font-semibold">זכויותיכם</h2>
              <p>
                יש לכם זכות לגשת למידע האישי שלכם, לתקן אותו, למחוק אותו או
                להתנגד לעיבוד שלו. צרו איתנו קשר אם ברצונכם לממש זכויות אלו.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-xl font-semibold">עדכונים למדיניות</h2>
              <p>
                אנו עשויים לעדכן את מדיניות הפרטיות מעת לעת. נודיע לכם על
                שינויים משמעותיים באמצעות הודעה בולטת באתר או באמצעות דואר
                אלקטרוני.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-xl font-semibold">יצירת קשר</h2>
              <p>
                אם יש לכם שאלות לגבי מדיניות הפרטיות שלנו, אנא צרו איתנו קשר
                בכתובת: support@platemate.com
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
